/**
 * Dashboard State Utilities
 *
 * Functions for determining and managing dashboard state
 */

import { DashboardState, DashboardStats } from '../types/dashboard';

export function getDashboardState(stats: DashboardStats): DashboardState {
  const hasConnections = stats.connectionCount > 0;
  const hasStories = stats.storyCount > 0;

  if (!hasConnections && !hasStories) return 'fresh';      // State 1
  if (hasConnections && !hasStories) return 'audience';    // State 2
  if (!hasConnections && hasStories) return 'lonely';      // State 3
  return 'active';                                          // State 4
}

export function getTimeOfDayGreeting(): string {
  const hour = new Date().getHours();

  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
}

export function formatRelativeTime(date: Date | string): string {
  // Convert string to Date if needed
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  const now = new Date();
  const diffMs = now.getTime() - dateObj.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} minute${diffMins === 1 ? '' : 's'} ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;

  return dateObj.toLocaleDateString();
}

export function getAvatarInitials(firstName: string, lastName?: string): string {
  if (lastName) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }
  return firstName[0].toUpperCase();
}

export const AVATAR_COLORS = [
  '#3B82F6', // Blue
  '#F59E0B', // Amber
  '#EC4899', // Pink
  '#8B5CF6', // Purple
  '#F97316', // Orange
  '#22C55E', // Green
  '#06B6D4', // Cyan
  '#EF4444', // Red
];

export function getAvatarColor(index: number): string {
  return AVATAR_COLORS[index % AVATAR_COLORS.length];
}
